<template>
  <section v-if="content" class="page articles">
    <div class="articles__title" :class="{'not-loaded': notLoaded}">
      <AppTitle v-if="isMobile" title="lof" size="medium"/>
      <AppTitle v-else title="labor of fashion" size="little"/>
    </div>

    <div class="articles__categories" v-if="content.acf.displayed_categories.length > 0">
      <div class="articles__categories__inner container">
        <a v-for="(item, index) in content.acf.displayed_categories" :key="index" class="articles__category" @click="onClickCategory($event, item.term_id)">
          {{ item.name }}
        </a>
      </div>
    </div>

    <div class="articles__container">

      <AppLoader ref="loader"/>

      <div class="articles__news-all" v-if="featuredNews">
        <div class="container">
          <div class="articles__news-all--full" :class="{'is-big': lastNews.length < 3}">
            <router-link :to="`/articles/${featuredNews.ID}`" class="articles__featured-news" ref="featuredNews">
              <div class="articles__featured-news__text vertical-text">
                  featured news
              </div>
              <div class="articles__featured-news__image">
                <img class="articles__featured-news__image__elem" :src="featuredNews.acf.preview_image.url" :alt="featuredNews.acf.preview_image.alt">
                <!-- <AppLazyImg :alt="featuredNews.acf.preview_image.alt" :url="featuredNews.acf.preview_image.url" :width="featuredNews.acf.preview_image.width" :height="featuredNews.acf.preview_image.height"/> -->
              </div>
              <div class="articles__featured-news__content">
                <p class="articles__featured-news__date" v-html="featuredNews.acf.date"></p>
                <h3 class="articles__featured-news__title" v-html="featuredNews.acf.displayed_title"></h3>
                <p v-if="featuredNews.acf.description" class="articles__featured-news__description" v-html="featuredNews.acf.description"></p>
              </div>
            </router-link>
            <div v-if="lastNews && news.length > 0" class="articles__last-news-all">
              <template v-for="(item, index) in lastNews">
                <AppNewsCard class="articles__last-news" ref="lastNewsCard" :hasDate="true" :content="item" :key="index" />
              </template>  
              <span class="articles__last-news__separator" :style="`top: ${lastNewsCardHeight}px`"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="articles__news-line" v-for="(item, index) in nextNews" :key="index">
        <div class="container">
          <div class="articles__next-news-all">
            <template v-for="(item2, index2) in item">
              <AppNewsCard class="articles__next-news" :hasDate="false" :content="item2" :key="index2" />
            </template>
          </div>
        </div>
      </div>
      
    </div>
    <div class="container">
      <div class="articles__more" @click="loadMore" v-show="canLoadMore">
        <AppButtonMore text="More news" ref="moreBtn"/>
      </div>
    </div>
  </section>
</template>

<script>
  import Page from '@/mixins/Page'
  import API from '@/mixins/API'

  import AppNewsCard from '@/components/AppNewsCard.vue'
  import AppTitle from '@/components/AppTitle.vue'
  import AppLoader from '@/components/AppLoader.vue'
  import AppButtonMore from '@/components/AppButtonMore.vue'
  // import AppLazyImg from '@/components/AppLazyImg.vue'

  import EventHub from '@/utils/EventHub'

  export default {
    name: 'Articles',

    mixins: [
        Page,
        API
    ],

    components: {
      AppTitle,
      AppNewsCard,
      AppLoader,
      AppButtonMore,
      // AppLazyImg
    },

    computed: {
      lastNews()
      {
        return this.news.filter((item, index) => {
          return index < 4
        })
      },
      nextNews()
      {
        let newsArrays = []

        for(let i = 4; i < this.news.length; i += 4)
        {
          let arr = []

          if(this.news[i])
          {
            arr.push(this.news[i])
          }

          if(this.news[i + 1])
          {
            arr.push(this.news[i + 1])
          }

          if(this.news[i + 2])
          {
            arr.push(this.news[i + 2])
          }

          if(this.news[i + 3])
          {
            arr.push(this.news[i + 3])
          }

          newsArrays.push(arr)
        }

        return newsArrays
      }

    },

    data() {
      return {
        canLoadMore: true,
        news: [],
        categories: [],
        featuredNews: null,
        lastNewsCardHeight: 0
      }
    },

    created()
    {
      this.addListeners()

      this.currentDataPage = 2

      this.isLoading = false
      this.selectedCategories = []

      const endpoint = '/wp-json/acf/v3/pages/44'

      this.loadDatas(endpoint, (res) => { 

        this.content = res

        this.loadFeaturedNews()
         this.loadNews()
      })
    },

    destroyed()
    {
      this.removeListeners()
    },

    methods: {
      onClickCategory(ev, id)
      {
        if(ev.target.classList.contains('is-active'))
        {
          ev.target.classList.remove('is-active')
          // delete the category
          const index = this.selectedCategories.indexOf(id)

          if (index > -1) {
            this.selectedCategories.splice(index, 1)
          }
        }
        else
        {
          ev.target.classList.add('is-active')
          this.selectedCategories.push(id)
        }
        
        this.loadNewsByCategories()
      },

      loadFeaturedNews()
      {
        const endpoint = `/wp-json/wp/v2/news/${this.content.acf.featured_news[0].ID}`

        this.fetchUrl(endpoint, (res) => {
          this.content.acf.featured_news[0].acf = res.acf
          this.featuredNews = this.content.acf.featured_news[0]
        })
      },

      loadNews()
      {
        const newsEndpoint = '/wp-json/wp/v2/news?per_page=8&offset=1'

        fetch(process.env.VUE_APP_WP_API + newsEndpoint)
          .then((res) => res.json())
          .then((res) =>
          {
            this.onLoadedDatas()  
            this.news = res
            this.$refs.moreBtn.addEventListeners()
            this.checkLoadMoreButton(res, true)
            this.$nextTick(() => {
              this.calculateCardHeight()
            })
          })
      },

      calculateCardHeight()
      {
        if(this.$refs.lastNewsCard && this.$refs.featuredNews)
        {
          const cardHeight0 = this.$refs.lastNewsCard[0].$el.offsetHeight
          const cardHeight1 = this.$refs.lastNewsCard[1].$el.offsetHeight
  
          this.lastNewsCardHeight = cardHeight0 > cardHeight1 ? cardHeight0 : cardHeight1
        }
      },

      loadNewsByCategories()
      {
        this.$refs.loader.enable()

        let newsEndpoint = `/wp-json/wp/v2/news?per_page=9&categories=`

        let additionalEndpoint = ''

        for(let i = 0; i < this.selectedCategories.length; i++)
        {
          if(i > 0)
          {
            additionalEndpoint += ','
          }

          additionalEndpoint += this.selectedCategories[i]
        }

        this.isLoading = true

        const url = process.env.VUE_APP_WP_API + newsEndpoint + additionalEndpoint

        fetch(url)
          .then((res) => res.json())
          .then((res) =>
          {
            if(res.length < 9)
            {
              this.canLoadMore = false
            }
            else
            {
              this.canLoadMore = true
            }

            if(res.length > 0)
            {
              this.featuredNews = res[0]
              this.news = res.slice(1)
            }
            else
            {
              this.featuredNews = null
              this.news = []
            }

            this.isLoading = false
            this.$refs.loader.disable()
          })
      },

      loadMore()
      {
        if(this.isLoadingMore)
          return

        this.isLoadingMore = true
        this.$refs.moreBtn.isLoading = true

        this.currentDataPage += 1

        let url

        if(this.selectedCategories.length > 0)
        {
          let additionalEndpoint = ''

          for(let i = 0; i < this.selectedCategories.length; i++)
          {
            if(i > 0)
            {
              additionalEndpoint += ','
            }

            additionalEndpoint += this.selectedCategories[i]
          }

          url = process.env.VUE_APP_WP_API + `/wp-json/acf/v3/news?per_page=4&page=${this.currentDataPage}&categories=${additionalEndpoint}&offset=${(this.currentDataPage - 1) * 4 + 1}`
        }
        else
        {
          url = process.env.VUE_APP_WP_API + `/wp-json/acf/v3/news?per_page=4&page=${this.currentDataPage}&offset=${(this.currentDataPage - 1) * 4 + 1}`
        }

        fetch(url)
          .then((res) => res.json())
          .then((res) =>
          {
            for(let i = 0; i < res.length; i++)
            {
              this.news.push(res[i])
            }

            this.checkLoadMoreButton(res)

            this.$refs.moreBtn.isLoading = false
            this.isLoadingMore = false
          })
      },

      checkLoadMoreButton(res, firstTime = false)
      {
          let newsNb = 4

          if(firstTime)
          {
            newsNb = 8
          }

          if(res.length < newsNb)
          {
            this.canLoadMore = false
          }
          else
          {
            this.canLoadMore = true
          }
      },

      addListeners()
      {
          EventHub.$on('window:resize', this.onResize)
      },

      removeListeners()
      {
          EventHub.$off('window:resize', this.onResize)
      },

      onResize()
      {
          this.calculateCardHeight()
      }
    }
  }
</script>


<style lang="stylus">
  .articles
    // padding-top 250px

    @media(max-width 768px)
      // padding-top 20px

  .articles__title
    margin-bottom 30px
    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

    @media(max-width 768px)
      padding-left $space-x-mobile

  .articles__categories
    width 100%
    // height 65px
    border-top 1px solid #a5a5a2
    interpolate('height', 768px, 2560px, 50px, 130px);

    @media(max-width 768px)
      display none

  .articles__categories__inner
    height 100%
    padding-left calc(100% / 36 * 3)
    display flex
    align-items center

  .articles__category
    position relative
    cursor pointer
    margin-right 35px
    text-transform uppercase

    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

    &:last-child
      margin-right 0

    &:after
      content ''
      position absolute
      top 50%
      left 0
      width 100%
      height 1px
      background-color $black
      transform-origin center right
      transform scaleX(0) scaleY(1)
      transition transform 0.4s $ease-in-out-circ

    &.is-active
      &:after
        transform scaleX(1) scaleY(1)
        transform-origin center left


  .articles__container
    position relative
    border-top 1px solid #a5a5a2

    @media(max-width 768px)
      width "calc(100vw -  %s * 2)" % $space-x-mobile
      margin 0 auto
      border-top 0px solid #a5a5a2

  .articles__news-all
    width 100%
    border-bottom 1px solid #a5a5a2

    @media(max-width 768px)
      border-bottom 0

  .articles__news-all--full
    width 100%
    display flex

    @media(max-width 768px)
      flex-direction column

  .articles__featured-news
    position absolute
    width 50%
    height 100%
    padding 35px calc(100% / 36) 60px calc(100% / 36 * 3)
    border-right 1px solid #a5a5a2

    .is-big &
      position relative

    @media(max-width 768px)
      position relative
      width calc(100% / 16 * 12)
      padding 0
      padding-left calc(100% / 16)
      padding-bottom 45px
      margin-bottom 10px
      border-right none

    &:after
      @media(max-width 768px)
        content ''
        position absolute 
        bottom 0
        left -1 * ($space-x-mobile)
        width 100vw
        height 1px
        background $black
  .articles__featured-news__text.vertical-text
    @media(max-width 768px)
      height auto
      transform translateX(-50%) rotate(180deg)

  .articles__featured-news__text
    position absolute
    top 0
    left 0
    height 100%
    text-align center
    text-transform uppercase
    transform translateX(-50%)

  .articles__featured-news__image, .articles__next-news__image
    position relative
    width 100%
    margin-bottom 40px

    &:before
      content ''
      display block
      padding-top 100%
  
  .articles__featured-news__image__elem, .articles__next-news__image__elem
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    object-fit cover

  .articles__featured-news__content
    width 60%

    @media(max-width 768px)
      width 100%
      padding-left 15px

  .articles__featured-news__date, .articles__next-news__date
    margin-bottom 20px
    line-height 1
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

  .articles__featured-news__title
    margin-bottom 20px
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 15px, 25px);

  .articles__featured-news__description
    interpolate('font-size', 1600px, 2560px, 20px, 30px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

  .articles__last-news-all
    position relative
    width 50%
    margin-left 50%
    display flex
    flex-wrap wrap

    .is-big &
      margin-left 0
      align-items flex-start

    @media(max-width 768px)
      width 100%
      margin-left 0
      flex-direction column
  
  .articles__last-news
    width calc(100% / 18 * 8)
    padding 35px calc(100% / 18) 60px calc(100% / 18)
    // display inline-block

    @media(max-width 768px)
      width calc(100% / 16 * 12)
      padding 0
      padding-left calc(100% / 16)
      margin-top 40px

    &:nth-of-type(1), &:nth-of-type(3)
      border-right 1px solid #a5a5a2

      @media(max-width 768px)
        border-right 0

 .articles__next-news__title
    text-transform uppercase

  .articles__last-news__separator
    position absolute
    left 0
    width 50vw
    height 1px
    background #a5a5a2

    @media(max-width 768px)
      display none

  .articles__news-line
    border-bottom 1px solid #a5a5a2

    @media(max-width 768px)
      border-bottom 0

  .articles__next-news-all
    padding 0 calc(100% / 36 * 2)
    display flex

    @media(max-width 768px)
      padding 0
      flex-direction column

  .articles__next-news
    width calc(100% / 32 * 8)
    padding 35px calc(100% / 32)
    border-right 1px solid #a5a5a2

    @media(max-width 768px)
      width calc(100% / 16 * 12)
      padding 0
      padding-left calc(100% / 16)
      margin-top 40px
      border-right none

    &:nth-child(4)
      border-right none

  .articles__more
    width calc(100% / 36 * 16)
    display block
    margin 100px auto 0 auto

    @media(max-width 768px)
      width 100%
      margin 80px auto 0 auto

</style>
